import { useQueryParam, withDefault } from "use-query-params";

import {
  type CompareDateRangeV2,
  CustomJsonParam,
} from "@north-beam/nb-common";

const CompareDateRangeQueryParam = CustomJsonParam<CompareDateRangeV2>();

export const useCompareDateRangeQueryParams = () => {
  const [compareDateRange, setCompareDateRange] = useQueryParam(
    "compareDateRange",
    withDefault<CompareDateRangeV2, CompareDateRangeV2>(
      CompareDateRangeQueryParam,
      { value: "previousPeriod" },
    ),
    { updateType: "pushIn" },
  );

  return { compareDateRange, setCompareDateRange };
};
